export const aboutMePics = [
    '/images/aboutMe/pic.jpg',
    '/images/aboutMe/miPicGuitar.jpg',
    '/images/aboutMe/miplaying1.PNG'
]